import { combineEpics } from "redux-observable";
import { epicPlayerSettingsInfo } from "./epics/epicPlayerSettingsInfo";
import { epicSetSound } from "./epics/epicSetSound";
export var epicPlayerSettings = combineEpics(epicSetSound, epicPlayerSettingsInfo);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/player-settings/epicPlayerSettings.ts
// module id = 1926
// module chunks = 3